import { useUnit } from 'effector-react'
import { useState } from 'react'
import { goToAuth } from '@/app/routing/events'
import { $userToken } from '@/entities/user'
import { purchaseKeyFx, triggerKeysRefetch } from '@/entities/cases'

export const useBuyKeys = () => {
  const [creatingInvoice, setCreatingInvoice] = useState(false)

  // const steamId = useUnit($steamId)
  const userToken = useUnit($userToken)
  // const walletStatus = useTonConnectUI()[0].connected

  const handleBuyKeys = async (id: number) => {
    if (!userToken) {
      return goToAuth()
    }

    // if (!steamId && !walletStatus) {
    //   return goToConnectPlatform({ platform: 'steam' })
    // }

    setCreatingInvoice(true)
    try {
      await purchaseKeyFx({ token: userToken, key_id: id })
    } finally {
      setCreatingInvoice(false)
      triggerKeysRefetch(userToken)
    }
  }

  return { handleBuyKeys, creatingInvoice }
}
